<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Editar grupo
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="title"
            :error-messages="formErrors.title"
            label="Titulo do grupo (Área de conhecimento)"
            hint="Ex: Linguagens, Códigos e suas Tecnologias"
            @input="formErrors.title = ''"
          />
          <v-text-field
            v-model="subtitle"
            :error-messages="formErrors.subtitle"
            label="Subtitulo do grupo (ex: Disciplinas) (opcional)"
            hint="Ex: Língua Portuguesa, Literatura, Língua Inglesa, Língua Espanhola e Arte."
            @input="formErrors.subtitle = ''"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],
  props: {
    group: { type: Object, default: undefined }
  },
  data: () => ({
    title: '',
    subtitle: ''
  }),
  computed: {
  },
  created () {
    if (this.group) {
      this.title = this.group.title
      this.subtitle = this.group.subtitle
    }
  },

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const data = {
        title: this.title,
        subtitle: this.subtitle
      }
      try {
        await this.$api.updateQuestionGroups(this.group.id, data)
        this.$store.dispatch('setSnackBar', { text: 'Grupo atualizado com sucesso!', color: 'green' })
        this.$emit('resolve', true)
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar o grupo, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
